"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTag = addTag;
exports.deleteTag = deleteTag;
exports.getTagAutocomplete = getTagAutocomplete;
exports.getTagDetail = getTagDetail;
exports.getTagList = getTagList;
exports.updateTag = updateTag;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取公司标签列表
 * @param pram
 * @constructor
 */
function getTagList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // const data = {
  //   tagName: pram.tagName,
  //   page: pram.page,
  //   limit: pram.limit,
  // };
  return (0, _requestMapi.default)({
    url: '/mapi/asset/emp/tag/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增标签
 * @param pram
 * @constructor
 */
function addTag(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/emp/tag/add',
    method: 'POST',
    data: pram
  });
}

/**
 * 更新标签
 * @param pram
 * @constructor
 */
function updateTag(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/emp/tag/update',
    method: 'POST',
    data: pram
  });
}

/**
 * 删除标签
 * @param id
 * @constructor
 */
function deleteTag(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/asset/emp/tag/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 获取标签详情
 * @param {*} id
 * @returns
 */
function getTagDetail(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/asset/emp/tag/info",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取标签自动补全列表（用于使用人群选择）
 * @param {string} keyword - 搜索关键词
 */
function getTagAutocomplete(keyword) {
  return (0, _requestMapi.default)({
    url: '/mapi/asset/emp/tag/autocomplete',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}